import { createContext, useContext, useEffect, useState } from "react";

const HEADER_CLASSES = {
  contractSearch: "",
  contractProcessing: "page-header-contract-processing-img",
  contractDetails: "page-header-contract-details-img",
  combinedDetails: "page-header-combined-contract-details-img",
  customerProfile: "page-header-customer-profile-img",
  reports: "page-header-reports-img",
  contractQuote: "page-header-contract-quote-img",
  combinedContractQuote: "page-header-combined-contract-quote-img",
  formsLibrary: "page-header-library-img",
  documentUpload: "page-header-document-upload-img",
  contractDocuments: "page-header-contract-documents-img",
  none: "",
};
const DEFAULT_HEADER_CLASS = "";

// ---- Contexts ----
const HeaderContext = createContext(null);
const PageHeaderValueContext = createContext({
  title: null,
  subtitle: null,
  actions: null,
});
const PageHeaderSetterContext = createContext(() => {});

const HeaderProvider = (props) => {
  const [headerClass, setHeaderClassState] = useState(DEFAULT_HEADER_CLASS);

  const getHeaderClass = () => headerClass;
  const setHeader = (header) =>
    setHeaderClassState(HEADER_CLASSES[header] || DEFAULT_HEADER_CLASS);
  const clearHeader = () => setHeader("");

  const [pageHeaderConfig, setPageHeaderConfig] = useState({
    title: null,
    subtitle: null,
    actions: null,
  });

  return (
    <HeaderContext.Provider
      value={{
        getHeaderClass,
        setHeader,
        clearHeader,
      }}
    >
      <PageHeaderSetterContext.Provider value={setPageHeaderConfig}>
        <PageHeaderValueContext.Provider value={pageHeaderConfig}>
          {props.children}
        </PageHeaderValueContext.Provider>
      </PageHeaderSetterContext.Provider>
    </HeaderContext.Provider>
  );
};

const HeaderConsumer = HeaderContext.Consumer;

const useHeader = () => useContext(HeaderContext);
const usePageHeaderConfig = () => useContext(PageHeaderValueContext);
const usePageHeader = ({ title, subtitle, actions } = {}) => {
  const setConfig = useContext(PageHeaderSetterContext);

  useEffect(() => {
    setConfig({ title, subtitle, actions });
    return () => setConfig({ title: null, subtitle: null, actions: null });
  }, [setConfig, title, subtitle, actions]);
};

export {
  HeaderProvider,
  HeaderConsumer,
  useHeader,
  usePageHeader,
  usePageHeaderConfig,
};
